import travelUi from '../assests/all imgs/Travel app UI.png';
import portfolioUi from '../assests/all imgs/Portfolio.png';
import reduxCrudUi from '../assests/all imgs/Redux crud.png';


const pHData = [
    {
        id:1,
        imgL:travelUi,
        pName:"Travel App UI",
        disc:"This is a Travel App, In this app you can see a Nice NAVBAR, FOOTER and MENU-ITEMS . The Website is complete responsive it is totaly fit in mobile and laptop.",
        view:'https://csb-psm4fd.netlify.app/',
        source:'https://github.com/loanwolf0/Travel-app-Ui',
        
        
    },
    {
        id:2,
        imgL:portfolioUi,
        pName:"Portfolio UI",
        disc:"By building this website I learnt many things. I also implement those things in my PORTFOLIO website.",
        view:'https://csb-qpj5yw.netlify.app/',
        source:'https://github.com/loanwolf0/portfolio',
        
    },
    {
        id:3,
        imgL:reduxCrudUi,
        pName:"Redux Crud Operation",
        disc:"This is website Where I impemented all crud operations CREATE,READ,UPDATE,DELETE. Here i used fekeApi to fetch data from api using id and we can edit,delete,read,create the post. ",
        view:'https://redux-crud-anurag.netlify.app/',
        source:'https://github.com/loanwolf0/Redux_CRUD',
        
    },
]

export default pHData;